<template>
<div class="chapter">
<div class="inner_page">
<a id="i246"></a><a id="i932"></a><a id="i1124"></a><a id="i1887"></a><a id="VPS-34"></a>
<h2 class="part">BOOK II</h2>
<h2 class="ptitle">Innocence at Risk</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Part2.vue?0839a864